import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

import TiposDocumentoSocioConstant from 'constants/tiposDocumentoSocio'

const TipoFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  return (
    <Form.Group>
      <Form.Label text='TIPO' htmlFor='select-tipo-documento' md={3} />
      <Col md={9}>
        <Field name='tipo'>
          {({ field }) => (
            <Form.Select
              {...field}
              disabled={fIsSubmitting}
              isInvalid={iTouched && iError}
              id='select-tipo-documento'
            >
              <option value=''>Seleccionar</option>
              {TiposDocumentoSocioConstant.__array.map(val => (
                <option key={val.id} value={val.id}>
                  {val.nombre}
                </option>
              ))}
            </Form.Select>
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(TipoFormGroup)
